
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15 1H8.83c-.533 0-1.044.212-1.42.59L2.59 6.41c-.378.376-.59.887-.59 1.42V17a2 2 0 002 2h11a2 2 0 002-2V3a2 2 0 00-2-2zM3.82 8L9 2.82V7a1 1 0 01-1 1H3.82zM14 13.5a.5.5 0 01-.5.5h-8a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h8a.5.5 0 01.5.5v1zM19 5v14a2 2 0 01-2 2H6a2 2 0 002 2h9c2.21 0 4-1.79 4-4V7a2 2 0 00-2-2z","fill":"nonzero"}})])
          )
        }
      }
    